import React from 'react';
import PropTypes from 'prop-types';
import { AppBar, Box, TextField, Toolbar, Typography } from '@mui/material';

function UserInfo({ user, contractorId, setContractorId }) {
  return (
    <>
      <AppBar position="static" color="secondary">
        <Toolbar variant="dense">
          <Typography variant="h6" color="inherit" component="div">
            User Info
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ paddingTop: '20px' }}>
        <TextField
          label="Name"
          defaultValue={user.name}
          fullWidth
          disabled
          size="small"
          sx={{ marginBottom: '20px' }}
        />
        <TextField
          label="Title"
          defaultValue={user.title}
          fullWidth
          disabled
          size="small"
          sx={{ marginBottom: '20px' }}
        />
        <TextField
          label="Company"
          defaultValue={user.company}
          fullWidth
          disabled
          size="small"
          sx={{ marginBottom: '20px' }}
        />
        <TextField
          label="Email"
          defaultValue={user.email}
          fullWidth
          disabled
          size="small"
          sx={{ marginBottom: '20px' }}
        />
        <TextField
          label="Phone"
          defaultValue={user.phoneNumber}
          fullWidth
          disabled
          size="small"
          sx={{ marginBottom: '20px' }}
        />
        <TextField
          label="Contractor Id"
          fullWidth
          size="small"
          sx={{ marginBottom: '20px' }}
          value={contractorId}
          onChange={(evt) => setContractorId(evt.target.value)}
        />
      </Box>
    </>
  );
}

UserInfo.propTypes = {
  user: PropTypes.object.isRequired,
  contractorId: PropTypes.string.isRequired,
  setContractorId: PropTypes.func.isRequired,
};

export default UserInfo;
